import $$ from './axios.service';
import signMd5Utils from '../../utils/sign.md5';
import { WEBSITE_CODE, WEBSITE_ID, TIME_DIFFERENCE } from '../../store/types';
import { getStorage } from '../../utils/storage';

// http method= { post | put }
export function httpAction(url, parameter, method) {
  const sign = signMd5Utils.getSign(url, parameter);
  const diff = window.sessionStorage.getItem(TIME_DIFFERENCE) || 0;
  // 将签名和时间戳，添加在请求接口 Header
  const signHeader = { 'X-Sign': sign, 'X-TIMESTAMP': signMd5Utils.getDateTimeToStringDiff(diff) };

  return $$({
    url,
    method,
    data: parameter,
    headers: signHeader
  });
}

// get
export function getAction(url, parameter) {
  const sign = signMd5Utils.getSign(url, parameter);
  // 将签名和时间戳，添加在请求接口 Header
  const diff = window.sessionStorage.getItem(TIME_DIFFERENCE) || 0;
  const signHeader = { 'X-Area-Code': getStorage(WEBSITE_CODE) || '', 'X-Area-Id': window.sessionStorage.getItem(WEBSITE_ID) || '', 'X-Sign': sign, 'X-TIMESTAMP': signMd5Utils.getDateTimeToStringDiff(diff) };

  return $$({
    url,
    method: 'get',
    params: parameter,
    headers: signHeader
  });
}

export function fetchRequest(url, parameter, callback) {
  const sign = signMd5Utils.getSign(url, parameter);
  // 将签名和时间戳，添加在请求接口 Header
  const diff = window.sessionStorage.getItem(TIME_DIFFERENCE) || 0;
  const signHeader = { 'X-Area-Code': getStorage(WEBSITE_CODE) || '', 'X-Area-Id': window.sessionStorage.getItem(WEBSITE_ID) || '', 'X-Sign': sign, 'X-TIMESTAMP': signMd5Utils.getDateTimeToStringDiff(diff) };

  return $$({
    url,
    method: 'get',
    params: parameter,
    headers: signHeader,
    responseType: 'blob',
    onDownloadProgress(progressEvent) {
      callback?.(progressEvent);
    }
  });
}

// post
export function postAction(url, parameter) {
  const sign = signMd5Utils.getSign(url, parameter);
  // 将签名和时间戳，添加在请求接口 Header
  const diff = window.sessionStorage.getItem(TIME_DIFFERENCE) || 0;
  const signHeader = { 'X-Area-Code': getStorage(WEBSITE_CODE) || '', 'X-Area-Id': window.sessionStorage.getItem(WEBSITE_ID) || '', 'X-Sign': sign, 'X-TIMESTAMP': signMd5Utils.getDateTimeToStringDiff(diff) };

  return $$({
    url,
    method: 'post',
    data: parameter,
    headers: signHeader
  });
}

// post postRequest postClient
export function postRequest(url, parameter, callback) {
  const sign = signMd5Utils.getSign(url, parameter);
  // 将签名和时间戳，添加在请求接口 Header
  const diff = window.sessionStorage.getItem(TIME_DIFFERENCE) || 0;
  const signHeader = { 'X-Area-Code': getStorage(WEBSITE_CODE) || '', 'X-Area-Id': window.sessionStorage.getItem(WEBSITE_ID) || '', 'X-Sign': sign, 'X-TIMESTAMP': signMd5Utils.getDateTimeToStringDiff(diff) };

  return $$({
    url,
    method: 'post',
    data: parameter,
    headers: signHeader,
    onUploadProgress(progressEvent) {
      callback?.(progressEvent);
    }
  });
}

// put
export function putAction(url, parameter) {
  return $$({
    url,
    method: 'put',
    data: parameter
  });
}

// delete
export function deleteAction(url, parameter) {
  return $$({
    url,
    method: 'delete',
    params: parameter
  });
}
